import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const COLS = [
  { title: "Shop", links: [
    ["Shop All", "/shop"], ["T-Shirts", "/shop?category=tshirts"], ["Sweatshirts", "/shop?category=sweatshirts"],
    ["Denim", "/shop?category=baggy-jeans"], ["Trousers", "/shop?category=trousers"], ["Shirts", "/shop?category=shirts"], ["Accessories", "/shop?category=accessories"],
  ]},
  { title: "The House", links: [
    ["Our Story", "/story"], ["The Journal", "/#journal"], ["Contact", "/story#contact"], ["Track Your Order", "/account?tab=track"],
  ]},
  { title: "Customer Care", links: [
    ["FAQs", "/story#faqs"], ["Shipping Policy", "/story#shipping"], ["Returns & Refunds", "/story#returns"], ["Privacy Policy", "/story#privacy"], ["Terms & Conditions", "/story#terms"],
  ]},
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-vv-black text-vv-ivory">
      <div className="px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 pb-16 border-b border-vv-ivory/10">
          <div className="col-span-2">
            <p className="font-display text-2xl tracking-[0.15em]">VELOUR <span className="italic font-light">&amp;</span> VANE</p>
            <p className="text-[10px] tracking-[0.4em] text-vv-ivory/50 mt-2">ESTD. 2024 — DESIGNED IN INDIA</p>
            <p className="text-sm text-vv-ivory/60 mt-6 max-w-xs leading-relaxed">
              Timeless. Refined. Yours. Contemporary essentials for the modern wardrobe.
            </p>
            <a data-testid="footer-instagram-link" href="https://instagram.com" target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-[11px] uppercase tracking-[0.25em] text-vv-ivory/70 hover:text-vv-ivory transition-colors">
              <Instagram size={14} strokeWidth={1.5} /> Instagram
            </a>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="vv-overline text-vv-champagne mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} to={to}
                      className="text-sm text-vv-ivory/60 hover:text-vv-ivory transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-[10px] tracking-[0.25em] uppercase text-vv-ivory/40">© 2025 Velour &amp; Vane. All rights reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-vv-ivory/40">PRICES IN INR ₹ · CARDS / UPI / COD</p>
        </div>
      </div>
      <div aria-hidden className="overflow-hidden select-none pointer-events-none pb-[2vw]">
        <p className="font-display text-[11.8vw] leading-[0.85] text-center text-vv-ivory/[0.04] tracking-[0.05em] whitespace-nowrap">
          VELOUR &amp; VANE
        </p>
      </div>
    </footer>
  );
}
